<template>
  <main-layout>
    <v-container>
      <main-menu />
      <h1 class="headline my-4">Page Config</h1>
      <table class="zw-table outline border-radius fullwidth strip">
        <tbody>
          <template v-for="item in items">
            <tr :key="item.value">
              <td>{{ item.label }}</td>
              <td class="text-xs-right">
                <toggle-button
                  :value="input[item.value]"
                  :sync="true"
                  :color="$vuetify.theme.success"
                  :labels="{ checked: 'ON', unchecked: 'OFF' }"
                  style="display: inline-block"
                  @change="handleChangeUnlockFeature(item.value)"
                />
              </td>
            </tr>
          </template>
        </tbody>
      </table>

      <ThemeConfig />
      <v-divider />

      <ExpiredConfig />

      <div class="caption mt-2 text-xs-center">
        *** หน้านี้จะแสดงเฉพาะผู้ใช้ที่เป็น zwiz เท่านั้น ***
      </div>
    </v-container>
  </main-layout>
</template>

<script>
import MainMenu from './MainMenu.vue'
import { ToggleButton } from 'vue-js-toggle-button'
import pageConfigApi from '@/api/page-config'
import { mapGetters } from 'vuex'
import { handleApiError } from '@/api/util'
import ThemeConfig from './ThemeConfig.vue'
import ExpiredConfig from './ExpiredConfig.vue'
export default {
  components: {
    MainMenu,
    ToggleButton,
    ThemeConfig,
    ExpiredConfig
  },
  data() {
    return {
      input: {
        unlock_webchat: false,
        unlock_livechat: false,
        unlock_whatsapp: false,
        unlock_instagram: false,
        unlock_open_bill: false,
        unlock_check_slip: false,
        unlock_read_all_chat: false,
        unlock_block_user: false,
        unlock_survey: false,
        unlock_ticket_3: false,
        unlock_knowledge_base: false,
        hide_template: false,
        unlock_beacon: false,
        unlock_audience: false,
        unlock_facebook_template: false
      },
      items: [
        { value: 'unlock_webchat', label: 'Unlock Webchat' },
        { value: 'unlock_livechat', label: 'Unlock Livechat' },
        { value: 'unlock_whatsapp', label: 'Unlock Whatsapp' },
        { value: 'unlock_instagram', label: 'Unlock Instagram' },
        { value: 'unlock_open_bill', label: 'Unlock Open Bill' },
        { value: 'unlock_check_slip', label: 'Unlock Check Slip' },
        { value: 'unlock_read_all_chat', label: 'Unlock Read All Chat' },
        { value: 'unlock_block_user', label: 'Unlock Block User' },
        { value: 'unlock_survey', label: 'Unlock Survey' },
        { value: 'unlock_ticket_3', label: 'Unlock Ticket 3' },
        { value: 'unlock_knowledge_base', label: 'Unlock Knowledge Base' },
        { value: 'hide_template', label: 'Hide Template (Shop, plug-in)' },
        { value: 'unlock_beacon', label: 'Unlock Beacon' },
        { value: 'unlock_audience', label: 'Unlock Audience' }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    const keys = Object.keys(this.input)
    keys.forEach((element) => {
      if (Object.hasOwnProperty.call(this.selectedBot, element)) {
        this.input[element] = this.selectedBot[element]
      }
    })
  },
  methods: {
    async handleChangeUnlockFeature(val) {
      try {
        this.$store.dispatch('loading')
        const response = await pageConfigApi.postUnlockFeature({
          data: {
            ...this.input,
            [val]: !this.input[val],
            page_id: this.selectedBot.pageid
          }
        })
        if (response.status == 200 || response.status == 204) {
          this.input[val] = !this.input[val]
          const currentBot = {
            ...this.selectedBot,
            [val]: this.input[val]
          }

          const newbotlist = this.$store.state.botlist
          const botIndex = newbotlist.findIndex((oldbot) => {
            return this.selectedBot.pageid == oldbot.pageid
          })
          if (newbotlist) {
            newbotlist[botIndex][val] = this.input[val]
            this.$store.dispatch('updateBotlist', newbotlist)
          }

          this.$store.dispatch('selectBot', currentBot)
          this.$swal.fire({
            title: this.$t('Successfully'),
            type: 'success'
          })
        }
        this.$store.dispatch('clear_loading')
      } catch (error) {
        handleApiError(error)
        this.$store.dispatch('clear_loading')
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/AdvancedSetting/PageConfig.vue